import { QUERY_KEYS } from '@/shared/api';
import { queryOptions } from '@tanstack/react-query';
import { getCreditInfo } from './v1';

export const creditQueries = {
  info: () =>
    queryOptions({
      queryKey: [QUERY_KEYS.GET_CREDIT_INFO],
      queryFn: getCreditInfo,
    }),
};
